<template>
  <Dialog v-model="visible" :title="$t('monopoly.extractSuccessTitle')">
    <div class="extract-success">
      <div class="reward-list" v-if="props.rewards.length">
        <div
          class="reward-item"
          v-for="(item, index) in props.rewards"
          :key="`${item.propId || item.propName}-${index}`"
        >
          <div class="icon-wrap">
            <img
              v-if="item.propId"
              class="icon"
              :src="getPropIcon(item.propId)"
              :alt="item.propId"
            >
          </div>
          <div class="name">
            {{ formatPropText(t, item) }}
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        {{ $t('monopoly.rewardEmpty') }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../Dialog/index.vue'
import { getPropIcon, formatPropText } from '@/views/act/monopoly/utils/prop'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  rewards: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})
</script>

<style lang="less" scoped>
.extract-success {
  width: 100%;
  color: #12215c;
  text-align: center;
}

.reward-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 28px 40px;
  width: 100%;
  padding: 20px 0 10px;
}

.reward-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
}

.icon-wrap {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 4px solid #E0FCFE;
  background: #b8e9ff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.icon {
  width: 72%;
  height: 72%;
  object-fit: contain;
}

.name {
  font-size: 26px;
  line-height: 1.4;
}

.empty {
  font-size: 26px;
  color: rgba(18, 33, 92, 0.6);
  padding: 40px 0;
}
</style>
